import { Product, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import { addFront } from 'rangeConfig/besta/behaviors/addFront';
import {
  matchDoorsToFrames,
  matchDoorStyleToFrames,
  matchDrawerOpeningToFrames
} from 'rangeConfig/besta/filters/mainMenuProductFilters';
import addFrontStyleToFrame from 'rangeConfig/shared/behaviors/addFrontStyleToFrame';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import { DoorIcon, DrawerIcon } from 'components/ProductSidebar/ProductCard/ProductCardSVGs';
import { getQPPImage } from 'products/utils';
import changeBestaFrontBehavior from 'rangeConfig/besta/behaviors/changeFront';

const getProductCardIcon = (product: Product) => {
  const icon =
    product.type === ProductType.BESTA_DRAWER_26_ASM ||
    product.type === ProductType.BESTA_DRAWER_38_ASM
      ? DrawerIcon
      : DoorIcon;

  return { icon };
};

const doorFrontCardSubtitle = (product: Product) => {
  return product.type === ProductType.BESTA_DRAWER_26_ASM ||
    product.type === ProductType.BESTA_DRAWER_38_ASM
    ? 'storageone.selectedProductFrontTypeDrawer designText, communicatedSizeText'
    : 'storageone.selectedProductFrontTypeDoor designText, communicatedSizeText';
};

export const combinationsProductListConfig: ProductListConfig = {
  cluster: ['name', 'design'],
  cardsTitle: 'name',
  cardsSubtitle: 'designText',
  productCardMainImage: getQPPImage,
  productCardHoverImage: getQPPImage,
  behaviors: {
    productClicked: [showDoors, changeBestaFrontBehavior],
    productDropped: [showDoors, addFrontStyleToFrame]
  },
  productFilters: [matchDoorStyleToFrames],
  sortOrder: [],
  categories: [
    {
      id: 'fronts',
      categoryTitle: '',
      products: [
        { path: 'type', value: ProductType.BESTA_DOOR_38_ASM },
        { path: 'type', value: ProductType.BESTA_DOOR_64_ASM },
        { path: 'type', value: ProductType.BESTA_DRAWER_26_ASM },
        { path: 'type', value: ProductType.BESTA_DRAWER_38_ASM },
        { path: 'type', value: ProductType.BESTA_DOOR_192_ASM }
      ]
    }
  ]
};

export const doorsAndDrawersProductListConfig: ProductListConfig = {
  cluster: [],
  cardsTitle: 'name',
  cardsSubtitle: doorFrontCardSubtitle,
  productCardIcon: getProductCardIcon,
  behaviors: {
    productClicked: [showDoors, addFront],
    productDropped: [showDoors, addFront]
  },
  productFilters: [matchDrawerOpeningToFrames, matchDoorsToFrames],
  sortOrder: [{ path: 'name' }, { path: 'designText' }, { path: 'communicatedSizeText' }],
  categories: [
    {
      id: 'doors_and_drawers',
      categoryTitle: '',
      products: [
        { path: 'type', value: ProductType.BESTA_DOOR_38_ASM },
        { path: 'type', value: ProductType.BESTA_DOOR_64_ASM },
        { path: 'type', value: ProductType.BESTA_DRAWER_26_ASM },
        { path: 'type', value: ProductType.BESTA_DRAWER_38_ASM },
        { path: 'type', value: ProductType.BESTA_DOOR_192_ASM }
      ]
    }
  ]
};
